export const VALID_CITIES = [
  "Chicago",
  "Los Angeles",
  "San Francisco",
  "Miami",
  "Las Vegas",
  "Boston",
  "Seattle",
  "Dallas",
  "Atlanta",
  "Orlando",
  "Philadelphia",
  "San Diego",
  "New York",
  "Nashville",
  "Houston",
  "New Orleans",
  "Denver",
  "Phoenix",
  "Austin",
  "Charlotte",
  "Tampa",
  "Portland",
  "Salt Lake City",
  "San Antonio",
  "Minneapolis",
  "St Louis",
  "Charleston",
  "Savannah",
  "Honolulu",
  // Add all valid cities here (use URL-friendly format)
];